<template>
  <div class="cartItem"
    :class="{ disabled: !isAvailable || statusMessage }">
    <p v-if="item.first" class="submitTo notranslate">{{ item.shopPageName || item.payload.shopItemName[lang] }}</p>
    <button type="button"
      class="btnDel toCapitalize"
      :style="isFloating && {...skinStyle('defaultBtnBg', 'border-color'), ...skinStyle('defaultBtnBg', 'color')}"
      @click="deleteItem">
      {{ locale.delete }}
    </button>
    <div class="checkbox">
      <input type="checkbox"
        :id="item.cartId"
        :disabled="!isAvailable || statusMessage"
        v-model="item.isChecked"
        @change="checkedItem">
      <label :for="item.cartId"></label>
    </div>
    <div class="inner">
      <p v-if="!isAvailable" class="validateMessage notranslate">{{locale.not_available}}</p>
      <p v-else-if="statusMessage" class="validateMessage">{{ statusMessage[lang] }}</p>
      <!-- info -->
      <div class="itemInfo">
        <div v-if="item.payload.thumb" class="thumb">
          <img :src="item.payload.thumb" alt="">
        </div>
        <div class="subject">
          {{item.payload.shopItemName[lang]}}
        </div>
      </div>
      <!-- //info -->

      <!-- !(required 최소수량 > 1 && hasOption) -->
      <!-- <div v-if="validateItemQuantity && !validateItemQuantity.result" class="validateStkr">
        {{ validateItemQuantity.remain }}개 더 주문해주세요.
        (현재 {{ validateItemQuantity.quantity }}개)
      </div> -->
      <div v-if="validateItemQuantity && !validateItemQuantity.result" class="validateStkr">
        {{ validateQuantityMessage }}
      </div>
      <!-- //!(required 최소수량 > 1 && hasOption) -->

      <!-- <div v-if="cooldown" class="validateStkr">
        {{ cooldown }}분 후 주문 가능합니다.
      </div> -->

      <div v-if="timeIsExpired" class="validateStkr">
        주문 시간이 만료되었습니다.
      </div>

      <!-- option -->
      <div class="itemOption">
        <div v-if="options && options.length" class="optionInfo">
          <div class="list">
            <div
              v-for="optionItem in options"
              :key="optionItem.id"
              class="row"
              :class="{isSubOption: optionItem.isSubOption}">
              <span class="label">{{ optionItem.name[lang] }}</span>
              <div class="value">
                <span
                  v-for="(optionItemsItem, index) in optionItem.optionItems"
                  :key="index"
                  class="valueArr">
                  {{ optionItemsItem.name[lang] }} ({{ optionItemsItem.quantity }})
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- //option -->
      <!-- price -->
      <div class="priceInfo toCapitalize">
        <div class="item itemQuantity productQuantity">
          <span class="label">{{locale.quantity}}</span>
          <span class="value">
            <button
              class="btnMinus"
              type="button"
              :class="{isLimit: limitQuantity('minus')}"
              :disabled="!isAvailable"
              @click.stop="setProductQuantity('minus')">
              -
            </button>
            <em>{{ itemQuantity }}</em>
            <button
              class="btnPlus"
              type="button"
              :class="{isLimit: limitQuantity('plus')}"
              :disabled="!isAvailable"
              @click.stop="setProductQuantity('plus')">
              +
            </button>
          </span>
        </div>
        <div v-if="detailPrice"
          class="item price priceDpBoard">
          <div class="label">{{locale.total}}</div>
          <div class="value">
            <em>{{ priceFormat(detailPrice.total)}} </em>
          </div>
        </div>
      </div>
      <!-- //price -->
      <div v-if="item.last" class="multiCartItem toCapitalize">
        <div v-if="item.multiCartPrice" class="priceDpBoard">
          <div class="total">
            <span class="label">{{locale.total}}</span>
            <span class="value">
              <em>{{priceFormat(item.multiCartPrice)}}</em>
            </span>
          </div>
        </div>
        <div class="btns">
          <button type="button" class="btn toCapitalize"
            :style="{
              ...skinStyle('productBtncart', 'background-color'),
              ...skinStyle('productBtncart', 'border-color'),
            }"
            @click="requestMultiCart">
            <span>{{priceFormat(item.multiCartPrice)}} / </span>
            {{locale.btn_request}}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import regExp from '@/common/regExp'
import { DateTime } from 'luxon'
import moment from 'moment/moment'
import AvailableTable from '@/components/Util/AvailableTable'
import { isAvailableNow } from '@/common/availableTimeChecker'
import { mapGetters } from 'vuex'

export default {
  name: 'CartShopItem',
  props: [
    'lang',
    'item',
    'locale',
    'isFloating',
    'multiCartAvailable',
    'itemData'
  ],
  components: {
    AvailableTable
  },
  computed: {
    ...mapGetters({
      pointColors: 'common/getPointColors',
    }),
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    currencyCode () {
      return this.$store.getters['common/getSetting'].currency.toUpperCase()
    },
    dateFormat () {
      const setting = this.$store.state.common.setting
      const date = setting.dateFormat[setting.dateformatDefault]
      return date
    },
    format () {
      const time = 'HH:mm'
      return `${this.dateFormat} ${time}`
    },
    options () {
      const options = (
        this.item &&
        this.item.payload &&
        this.item.payload.options
      ) || []

      if (!Array.isArray(options)) return []

      const parents = []
      const childrenByKey = new Map()

      for (const option of options) {
        const isChild = !!option.parentOption
        const groupId = option.id || option.optionId

        for (const optionItem of option.optionItems || []) {
          const row = {
            id: `${groupId}_${optionItem.optionItemId}`,
            groupId,
            name: option.name,
            optionItems: [optionItem]
          }

          if (!isChild) {
            parents.push(row)
            continue
          }

          const child = {
            ...row,
            parentOption: option.parentOption,
            parentOptionItem: option.parentOptionItem,
            isSubOption: true
          }

          const key = `${child.parentOption}_${child.parentOptionItem}`
          const children = childrenByKey.get(key) || []

          children.push(child)
          childrenByKey.set(key, children)
        }
      }

      const result = []

      for (const parent of parents) {
        result.push(parent)

        const parentOptionItem = parent.optionItems[0]
        const key = `${parent.groupId}_${parentOptionItem.optionItemId}`
        const children = childrenByKey.get(key)

        if (children) {
          result.push(...children)
          childrenByKey.delete(key)
        }
      }

      // 매칭되지 않은 데이터도 누락시키지 않기 위한 안전장치
      for (const children of childrenByKey.values()) {
        result.push(...children)
      }

      return result
    },
    detailPrice () {
      return this.$store.getters['shop/getShopItemPrice'](this.item)
    },
    getProperty () {
      return this.$store.getters['shop/getItemProperty'](this.item.shopItemId)
    },
    orderCooldown () {
      const shopPageId = this.item.shopPageId
      const shopCatCode = this.$store.getters['shop/getShopCatCode'](shopPageId)
      return this.cooldown && this.$store.getters['shop/getWaitingOrder'](shopCatCode)
    },
    // 주문대기 시간 체크
    cooldown () {
      const isIgnoreItem = this.$store.getters['shop/getIgnoreWaitingItem'](this.item.shopItemId)
      const cooltime = this.$store.getters['shop/getWaitingOrder'](this.item.catCode)
      return !isIgnoreItem && cooltime
    },
    categoryItemLimit () {
      const shopCatCode = this.item.catCode
      const categoryId = this.item && this.item.payload && this.item.payload.categoryId
      const limitCount = categoryId && this.$store.getters['shop/getCategoryLimitCount'](this.item.shopPageId, shopCatCode, categoryId)
      return limitCount
    },
    // 주문가능시간이 만료되었을 때
    timeIsExpired () {
      return this.$store.getters['shop/getShopOrderTimeout'](this.item.shopPageId)
    },
    // 실제 선택 가능한 수량 최대치
    possibleMax () {
      const shopCatCode = this.item.catCode
      const shopItemId  = this.item.shopItemId

      // 아이템 자체 한도 (장바구니/빌링 반영됨): 장바구니 이므로 현재 개수를 + 해야함
      const getItemMax = Number(this.$store.getters['shop/getItemPossibleMax'](shopCatCode, shopItemId, true))
      const itemMax = getItemMax + this.itemQuantity 

      // 카테고리 한도: 없으면 Infinity 로 처리해 min 계산 시 무시
      const catRaw = this.categoryItemLimit && this.categoryItemLimit.possibleMax
      const hasCat = catRaw !== null && catRaw !== undefined // 0은 통과
      const catMax = hasCat ? Number(catRaw) : Infinity

      // 둘 중 작은 값 선택, 음수 방지(0 허용), 정수 사용 시 내림
      const minVal = Math.min(itemMax, catMax)
      return Math.max(0, Math.floor(minVal))
    },
    validateItemQuantity () {
      const shopItemId = this.item.shopItemId
      const itemInfo = this.item.payload
      const selectOptionByQuantity = itemInfo.selectOptionByQuantity
      const cartShopItems = this.$store.getters['cart/getCartShopItems'](shopItemId)
      return selectOptionByQuantity && cartShopItems ? {
        required: cartShopItems.required, // 최소수량
        quantity: cartShopItems.currentQuantity, // 현재 선택한 수량
        remain: cartShopItems.required - cartShopItems.currentQuantity,
        result: cartShopItems.required <= cartShopItems.currentQuantity
      } : null
    },
    validateQuantityMessage () {
      const itemQuantity = this.validateItemQuantity
      const message = itemQuantity && itemQuantity.remain && this.locale.required_more_items.replace('{var}', itemQuantity.remain)
      const current = itemQuantity && itemQuantity.quantity && this.locale.currently_unit.replace('{var}', itemQuantity.quantity)
      return `${message} (${current})`
    },
  },
  watch: {
    isAvailable: {
      handler (isAvailable) {
        this.$emit('checkedItem', { cartId: this.item.cartId, isChecked: isAvailable })
      },
      immediate: true
    },
    statusMessage: {
      handler (status) { // 품절데이터 있으면
        if (status) {
          this.$emit('checkedItem', { cartId: this.item.cartId, isChecked: false })
        }
      },
      deep: true
    },
    getProperty: {
      handler (data) {
        if (data) {
          if (data.availableTime) {
            this.dataSync.availableTime = data.availableTime
          }
          if (data.status) {
            this.dataSync.status = data.status
          }
        }
      },
      deep: true
    },
    dataSync: {
      handler (data) {
        if (data.availableTime) {
          this.availableTime = this.$store.getters['shop/getPresetProperty']('availableTime', data.availableTime)
        }
        if (data.status) {
          const message = this.$store.getters['shop/getPresetProperty']('status', data.status)
          this.statusMessage = message && message.text
        }
      },
      deep: true
    },
    validateItemQuantity: {
      deep: true,
      handler (data) {
        const cartId = this.item.cartId // 인덱스보다 확실한 id가 필요함
        const isValid = (data && typeof data === 'object' && typeof data.result === 'boolean')
          ? data.result
          : true
        this.$emit('isValidItem', cartId, isValid)
        if (!isValid && this.item.isChecked) {
          this.$emit('checkedItem', { cartId: this.item.cartId, isChecked: false })
        }
        if (isValid && !this.item.isChecked) {
          this.$emit('checkedItem', { cartId: this.item.cartId, isChecked: true })
        }
      }
    },
    detailPrice: {
      deep: true,
      handler (data) {
        const totalPrice = data && data.total
        // this.$emit('updatePrice', { cartId: this.item.cartId, price: totalPrice })
        this.$store.commit('cart/setItemPrice', { cartId: this.item.cartId, price: totalPrice })
        this.$emit('setPriceShopItem', this.item.cartId, totalPrice)
      }
    },
  },
  async created () {
    if (this.item && this.item.payload && this.item.payload.quantity) {
      this.itemQuantity = this.item.payload.quantity
    }
    if (this.item && this.item.payload && this.item.payload.availableTime) {
      this.dataSync.availableTime = this.item.payload.availableTime.availableTime
    }
    if (this.item && this.item.payload && this.item.payload.status) {
      this.dataSync.status = this.item.payload.status
    }
  },
  beforeDestroy () {
    if (this.checkAvailable) {
      clearInterval(this.checkAvailable)
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.availableTime) {
        this.checkAvailableTime()
      }
    })
  },
  data () {
    return {
      itemQuantity: 1,
      checkAvailable: 0,
      isAvailable: true,
      dataSync: {
        availableTime: null,
        status: null
      },
      statusMessage: null,
      availableTime: null
    }
  },
  methods: {
    checkAvailableTime () {
      const check = () => {
        this.isAvailable = isAvailableNow(this.availableTime, moment())
      }

      check()
      this.checkAvailable = setInterval(check, 60000)
    },
    skinStyle (target, attr) {
      return this.pointColors(target, attr)
    },
    isEmpty (str) {
      return str && regExp.replaceAllEmpty(str).length <= 0
    },
    submitTo (submitId) {
      // const code = this.submitCode.find(x => x.id === submitId)
      // return code ? code.label : null
      // return this.item.payload
    },
    checkedItem (e) {
      const isChecked = e.target.checked
      this.$emit('checkedItem', { cartId: this.item.cartId, isChecked: isChecked })
    },
    priceFormat (price) {
      const currency = this.$store.getters['shop/getShopCurrency'] || null
      return this.$store.getters['util/getPriceFormatter'](price, currency)
    },
    deleteItem (e) {
      let id = []
      e.stopPropagation()
      id.push(this.item.cartId)
      this.$emit('delete', id)
    },
    limitQuantity (plusMinus) {
      const quantity = this.itemQuantity
      const min = 1
      const max = 10
      const plus = plusMinus === 'plus'
      const minus = plusMinus ==='minus'
      return (plus && quantity === max) || (minus && quantity === min)
    },
    setProductQuantity (plusMinus) {
      let quantity = this.itemQuantity
      const item = this.item
      if (!item) return
      const itemQty = item && item.payload && item.payload.selectQuantity
      const itemPossibleMax = this.possibleMax
      const min = itemQty.min || 1
      const max = itemPossibleMax
      const plus = plusMinus === 'plus'
      const minus = plusMinus ==='minus'
      if (plus) {
        if (max > this.itemQuantity) {
          this.itemQuantity += 1
        }
        // this.itemQuantity = quantity + 1 >= max ? max : quantity + 1
      }
      if (minus) {
        const requiredMin = this.item.payload.selectOptionByQuantity ? 1 : min
        if (requiredMin < this.itemQuantity) {
          this.itemQuantity -= 1
        }
        // this.itemQuantity = quantity - 1 < min ? min : quantity - 1
      }
      this.$store.commit('cart/setItemQuantity', {cartId: this.item.cartId, quantity: this.itemQuantity})
      this.$emit('setQuantityShopItem', this.item.cartId, this.itemQuantity)
    },
    requestMultiCart () {
      this.$emit('requestMultiCart', null, this.item.shopPageId)
    }
  }
}
</script>
